export const environment = {
  production: true,
  dev: false,
  API_URL: null,
  AVATAR_URL: '../../../../../assets/img/img_avatar.png',
};
